import React from "react";
import MAP_IMAGE from "../../../assets/img/map.jpg";
import { LocationAddress, LocationMap, LocationWrapper } from "./styled";

function Location({
  address,
  coordinates,
  googleAddress,
  name,
  telephoneNumber,
}) {
  const formattedCoordinates = (coordinates) => {
    const newCoordinates = { lat: 0, lng: 0 };
    newCoordinates.lat = parseFloat(coordinates.lat);
    newCoordinates.lng = parseFloat(coordinates.lng);
    return newCoordinates;
  };

  const parsedAddress = (address) => {
    return address.replace("|", "<br />");
  };

  const locations = [
    {
      name: "Traverse City",
      address: "697 Hannah Avenue| Suite C, Traverse City, MI 49686",
    },
    {
      name: "Cadillac",
      address: "124 S Mitchell St| Cadillac, MI 49601",
    },
    {
      name: "Petoskey",
      address: "228 E Mitchell St| Petoskey, MI 49770",
    },
    {
      name: "Lake City",
      address: "200 Main St Suite A| Lake City, MI 49651",
    },
    {
      name: "Manton",
      address: "113 W Main St| Manton, MI 49663",
    },
  ];

  return (
    <LocationWrapper id="nav-location">
      <LocationAddress>
        <h2>Our Locations</h2>
        {locations.map((location) => (
          <div className="group" key={location.name}>
            <div className="star">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 50 50"
                fill="red"
              >
                <polygon points="25,1 31,18 50,18 34,29 40,46 25,36 10,46 16,29 1,18 20,18" />
              </svg>
            </div>
            <div className="test">
              <h3>{location.name}</h3>
              <p>
                <a>
                  {location.address.split("|").map((line, index) => (
                    <React.Fragment key={index}>
                      {line.trim()}
                      {index < location.address.split("|").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </a>
              </p>
            </div>
          </div>
        ))}
      </LocationAddress>
      <LocationMap>
        <div className="duh">
          <img src={MAP_IMAGE} alt="Map of our locations" />
        </div>
      </LocationMap>
    </LocationWrapper>
  );
}

export default Location;
